import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ActionItem } from '../action-item/entities/action-item.entity';

@Component({
    standalone: true,
    selector: 'sh-tab-navigation',
    templateUrl: './tab-navigation.component.html',
    styleUrls: ['./tab-navigation.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule]
})
export class ShTabNavigationComponent {
    @Input() tabs!: Array<ActionItem>;
    @Input() activeTab!: number;

    public onSelect(index: number): void {
        if (this.activeTab !== index) {
            this.activeTab = index;
        }
    }
}
